import React from 'react';

import { Svg, SvgPath, SvgProps } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

const MARKER_DIMENSIONS = {
  width: 33,
  height: 45,
  viewBox: '0 0 33 45',
} as const;

const DELIVERY_WORK_PATHS = {
  background:
    'M16.789.327C8.333.327 1.494 7.166 1.494 15.62c0 11.471 15.295 28.405 15.295 28.405S32.084 27.092 32.084 15.62c0-8.455-6.84-15.294-15.295-15.294Z',
  content:
    'M15.667 7.333h2.666a1.333 1.333 0 0 1 1.334 1.334V10h2.666a1.334 1.334 0 0 1 1.334 1.333v7.334A1.334 1.334 0 0 1 22.333 20H11.667c-.74 0-1.334-.6-1.334-1.333v-7.334c0-.74.594-1.333 1.334-1.333h2.666V8.667c0-.74.594-1.334 1.334-1.334ZM18.333 10V8.667h-2.666V10h2.666Z',
} as const;

const COLORS = {
  background: primitive.bk.$bbqBrown,
  content: '#fff',
} as const;

interface DeliveryWorkMarkerProps extends SvgProps {
  accessibilityLabel?: string;
  testID?: string;
}

const defaultAccessibilityLabel = 'Delivery work marker';

export const DeliveryWorkMarker: React.FC<DeliveryWorkMarkerProps> = ({
  accessibilityLabel,
  testID,
  ...svgProps
}) => {
  return (
    <Svg
      width={MARKER_DIMENSIONS.width}
      height={MARKER_DIMENSIONS.height}
      viewBox={MARKER_DIMENSIONS.viewBox}
      fill="none"
      accessible={true}
      accessibilityLabel={accessibilityLabel || defaultAccessibilityLabel}
      testID={testID}
      {...svgProps}
    >
      <SvgPath d={DELIVERY_WORK_PATHS.background} fill={COLORS.background} />
      <SvgPath d={DELIVERY_WORK_PATHS.content} fill={COLORS.content} />
    </Svg>
  );
};

export const deliveryWorkMarkerSvg = `<svg width="${MARKER_DIMENSIONS.width}" height="${MARKER_DIMENSIONS.height}" viewBox="${MARKER_DIMENSIONS.viewBox}" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="${DELIVERY_WORK_PATHS.background}" fill="${COLORS.background}" />
  <path d="${DELIVERY_WORK_PATHS.content}" fill="${COLORS.content}" />
</svg>`;
